export function sendScrollIntoView() {
    window.parent.postMessage({ type: 'host/scrollIntoView' }, '*');
}
